import { CheckCircleTwoTone, ExclamationCircleTwoTone } from "@ant-design/icons";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";

/**
 * Column definitions for Parked Bills table.
 */
export const parkedBillColumns = [
  {
    title: "Parked Sale",
    dataIndex: "parkedTime",
    key: "parkedTime",
    width: "20%",
  },
  {
    title: "Document No",
    dataIndex: "parkedDocNo",
    key: "parkedDocNo",
    width: "25%",
  },
  {
    title: "Customer",
    dataIndex: "customer",
    key: "customer",
    width: "20%",
  },
  {
    title: "Qty",
    dataIndex: "qty",
    key: "qty",
    width: "20%",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "15%",
  },
];

/**
 * Column definitions for Order History table.
 */
export const orderHistoryColumns = () => {
  const posConfigStore = JSON.parse(localStorage.getItem("posConfigStore")) || {};

  const showEstimateNoInSalesHistory = usePOSConfigStore.getState().posConfig?.showEstimateNoInSalesHistory ?? posConfigStore?.state?.posConfig?.showEstimateNoInSalesHistory;
  const hideSalesAmount = (usePOSConfigStore.getState().posConfig?.hideSalesAmountInSalesHistory ?? posConfigStore?.state?.posConfig?.hideSalesAmountInSalesHistory) === "Y";
  const colWidth = hideSalesAmount ? "25%" : "20%";
  return [
    {
      title: "Document Number",
      dataIndex: "documentno",
      key: "documentno",
      width: colWidth,
    },
    ...(showEstimateNoInSalesHistory === "Y"
      ? [
          {
            title: "Estimate Number",
            dataIndex: "estimateDocumentNo",
            key: "estimateDocumentNo",
            width: colWidth,
            render: (text) => text || "",
          },
        ]
      : []),
    {
      title: "Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: colWidth,
    },
    {
      title: "Customer",
      dataIndex: "name",
      key: "name",
      width: colWidth,
    },
    ...(!hideSalesAmount
      ? [
          {
            title: "Total Amount",
            dataIndex: "total",
            key: "total",
            width: colWidth,
          },
        ]
      : []),
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: colWidth,
      filters: [
        { text: "Layaway", value: "Layaway" },
        { text: "Credit Sale", value: "Credit Sale" },
        { text: "Return", value: "Return" },
        { text: "Receipt", value: "Receipt" },
      ],
      onFilter: (value, record) => record?.type === value,
      render: (text, record) => {
        let colorStyle;
        switch (record.type) {
          case "Layaway":
            colorStyle = { color: "#007BFF" };
            break;
          case "Credit Sale":
            colorStyle = { color: "#007BFF" };
            break;
          case "Return":
            colorStyle = { color: "#f0ad4e" };
            break;
          case "Receipt":
            colorStyle = { color: "#28a745" };
            break;
          default:
            colorStyle = {};
        }

        return (
          <div style={{ position: "relative" }}>
            <span style={colorStyle}>{text}</span>
            {record.status === "Success" ? (
              <CheckCircleTwoTone
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  marginLeft: "1vw",
                  position: "absolute",
                  right: 1,
                  top: "15%",
                }}
                twoToneColor="#A4CD38"
              />
            ) : (
              <ExclamationCircleTwoTone
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  marginLeft: "1vw",
                  position: "absolute",
                  right: 1,
                  top: "15%",
                }}
                twoToneColor="red"
              />
            )}
          </div>
        );
      },
    },
  ];
};

/**
 * Column definitions for Cash Management table.
 */
export const cashManagementColumns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: "30%",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: "30%",
    render: (text, record) => {
      return record.type === "cashOut"
        ? "Cash Out"
        : record.type === "pettyCashOut"
          ? "Petty Cash Out"
          : record.type === "pettyCashIn"
            ? "Petty Cash In"
            : record.type === "bankTransfer"
              ? "Bank Transfer"
              : "Cash In";
    },
  },
  {
    title: "Reasons",
    dataIndex: "note",
    key: "note",
    width: "33%",
  },
  {
    title: "Transactions(Rs)",
    dataIndex: "amount",
    key: "amount",
    width: "20%",
    render: (text, record) => {
      return record.type === "cashOut" || record.type === "pettyCashOut" || record.type === "bankTransfer" ? <span style={{ color: "red" }}>-{record.amount}</span> : record.amount;
    },
  },
];
